import { Toaster } from 'sonner';
import { AppRoutes } from './routes';
import { AmplifyProvider } from '@/providers/amplify-provider';

export function App() {
  return (
    <AmplifyProvider>
      <AppRoutes />
      <Toaster
        position="top-right"
        toastOptions={{
          classNames: {
            success: 'bg-alert-success-muted border-alert-success text-alert-success-text',
            error: 'bg-alert-danger-muted border-alert-danger text-body',
            warning: 'bg-alert-caution-muted border-alert-caution text-body',
            info: 'bg-alert-blue-muted border-alert-blue text-body',
          },
        }}
      />
    </AmplifyProvider>
  );
}
